import { Link } from "react-router-dom";
import { ReactComponent as LogoIcon } from "../../../Assets/Frame 1.svg";
import { ReactComponent as TwitterIcon } from "../../../Assets/codicon_twitter.svg";
import { ReactComponent as FacebookIcon } from "../../../Assets/simple-icons_facebook.svg";
import { ReactComponent as InstagramIcon } from "../../../Assets/grommet-icons_instagram.svg";
import { ReactComponent as LinkedinIcon } from "../../../Assets/mingcute_linkedin-fill.svg";
import { LISTING_PAGE_CONFIG } from "../libs/categoryRoutes";
import { MARKET, ACCOUNT } from "../libs/marketplaceRoutes";
import "../marketplace-layout.css";
import "./MarketplaceFooter.css";

const SHOP_LINKS = [
  { to: MARKET.DEALS_TRENDING, label: "Trending deals" },
  { to: MARKET.DEALS_TODAY, label: "Today's deals" },
  { to: MARKET.DEALS_TOP_SELLING, label: "Top selling" },
  { to: MARKET.DEALS_RECOMMENDED, label: "Recommended" },
];

const CATEGORY_LINKS = Object.entries(LISTING_PAGE_CONFIG)
  .filter(([path]) => !path.includes("/deals/"))
  .slice(0, 8)
  .map(([to, cfg]) => ({ to, label: cfg.breadcrumb }));

const HELP_LINKS = [
  { to: MARKET.TRACK_ORDER, label: "Track your order" },
  { to: MARKET.RETURN_POLICY, label: "Returns & refunds" },
  { to: "/Contact", label: "Contact support" },
  { to: MARKET.RETURN_POLICY, label: "FAQs" },
];

const ACCOUNT_LINKS = [
  { to: ACCOUNT.HOME, label: "My profile" },
  { to: ACCOUNT.ORDERS, label: "My orders" },
  { to: ACCOUNT.SAVED, label: "Saved items" },
  { to: ACCOUNT.ADDRESSES, label: "Address book" },
  { to: ACCOUNT.SETTINGS, label: "Settings" },
];

const SOCIAL = [
  { href: "https://x.com/StexS2025?t=SzV18qb4-LOdiObsaggbTQ&s=09", icon: TwitterIcon, label: "Twitter" },
  { href: "https://www.facebook.com/share/1R55PoVDq4/", icon: FacebookIcon, label: "Facebook" },
  { href: "https://www.instagram.com/stexlogistics", icon: InstagramIcon, label: "Instagram" },
  { href: "https://www.linkedin.com/in/smart-trans-express-stex-63744834a", icon: LinkedinIcon, label: "LinkedIn" },
];

const MarketplaceFooter = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="marketplace-footer" aria-label="Marketplace footer">
      <div className="marketplace-container">
        <div className="marketplace-footer__grid">
          <div className="marketplace-footer__brand">
            <Link to="/market" className="marketplace-footer__logo">
              <LogoIcon aria-hidden="true" />
            </Link>
            <p>
              Nigeria&apos;s marketplace for everyday essentials, fashion, electronics,
              groceries, and more — powered by Smart Trans Express.
            </p>
            <div className="marketplace-footer__social">
              {SOCIAL.map(({ href, icon: Icon, label }) => (
                <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label}>
                  <Icon />
                </a>
              ))}
            </div>
          </div>

          <div className="marketplace-footer__col">
            <h3>Shop</h3>
            <ul>
              {SHOP_LINKS.map(({ to, label }) => (
                <li key={to}>
                  <Link to={to}>{label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="marketplace-footer__col">
            <h3>Categories</h3>
            <ul>
              {CATEGORY_LINKS.map(({ to, label }) => (
                <li key={to}>
                  <Link to={to}>{label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="marketplace-footer__col">
            <h3>Customer care</h3>
            <ul>
              {HELP_LINKS.map(({ to, label }) => (
                <li key={`${to}-${label}`}>
                  <Link to={to}>{label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="marketplace-footer__col">
            <h3>Your account</h3>
            <ul>
              {ACCOUNT_LINKS.map(({ to, label }) => (
                <li key={to}>
                  <Link to={to}>{label}</Link>
                </li>
              ))}
            </ul>
            <Link to="/market/sell" className="marketplace-footer__merchant-cta">
              Become a merchant
            </Link>
          </div>
        </div>

        <div className="marketplace-footer__trust">
          <span>Secure checkout</span>
          <span>·</span>
          <span>Door delivery & pickup</span>
          <span>·</span>
          <span>Order tracking</span>
          <span>·</span>
          <span>Easy returns</span>
        </div>

        <div className="marketplace-footer__bottom">
          <p>&copy; {year} Smart Trans Express (STEX). All rights reserved.</p>
          <nav className="marketplace-footer__legal" aria-label="Legal links">
            <Link to="/About">About STEX</Link>
            <Link to="/Privacy">Privacy &amp; terms</Link>
            <Link to="/Blog">Blog</Link>
            <Link to="/">Logistics home</Link>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default MarketplaceFooter;
